/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkAlcoBottleWineIcon16Light } from './FoodDrinkAlcoBottleWineIcon16Light';
import { FoodDrinkAlcoBottleWineIcon16Regular } from './FoodDrinkAlcoBottleWineIcon16Regular';
import { FoodDrinkAlcoBottleWineIcon16Solid } from './FoodDrinkAlcoBottleWineIcon16Solid';
import { FoodDrinkAlcoBottleWineIcon20Light } from './FoodDrinkAlcoBottleWineIcon20Light';
import { FoodDrinkAlcoBottleWineIcon20Regular } from './FoodDrinkAlcoBottleWineIcon20Regular';
import { FoodDrinkAlcoBottleWineIcon20Solid } from './FoodDrinkAlcoBottleWineIcon20Solid';
import { FoodDrinkAlcoBottleWineIcon24Regular } from './FoodDrinkAlcoBottleWineIcon24Regular';
import { FoodDrinkAlcoBottleWineIcon24Solid } from './FoodDrinkAlcoBottleWineIcon24Solid';
import { FoodDrinkAlcoBottleWineIcon32Regular } from './FoodDrinkAlcoBottleWineIcon32Regular';
import { FoodDrinkAlcoBottleWineIcon64Regular } from './FoodDrinkAlcoBottleWineIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkAlcoBottleWineIcon16Light,
        regular: FoodDrinkAlcoBottleWineIcon16Regular,
        solid: FoodDrinkAlcoBottleWineIcon16Solid,
    },
    20: {
        light: FoodDrinkAlcoBottleWineIcon20Light,
        regular: FoodDrinkAlcoBottleWineIcon20Regular,
        solid: FoodDrinkAlcoBottleWineIcon20Solid,
    },
    24: {
        regular: FoodDrinkAlcoBottleWineIcon24Regular,
        solid: FoodDrinkAlcoBottleWineIcon24Solid,
    },
    32: {
        regular: FoodDrinkAlcoBottleWineIcon32Regular,
    },
    64: {
        regular: FoodDrinkAlcoBottleWineIcon64Regular,
    },
};
export var FoodDrinkAlcoBottleWineIcon = forwardRef('FoodDrinkAlcoBottleWineIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
